import type { ReactElement } from 'react';
import { Fragment } from 'react';
import { useGallery } from '../../../../../provider/GalleryProvider';
import type { SearchResultFragmentOverview, SearchResultsOverview } from '../../../../../types';
import './SearchResultsSummary.scss';
import SearchResultList from './SearchResultList';
import { Card } from '@fastnorth/react-cerberus/Card';

const SearchResultsSummary = (): ReactElement => {
  const { searchResults } = useGallery();
  const { resultsOverview } =
    searchResults ||
    ({
      total: 0,
      resultsOverview: [] as SearchResultFragmentOverview[],
      tags: [''],
    } as SearchResultsOverview);

  return (
    <Card>
      <Card.Body>
        {resultsOverview.map((overview, idx) => (
          <Fragment key={overview.tag}>
            <SearchResultList fragmentOverview={overview} />
            {idx !== resultsOverview.length - 1 && <div key={`divider-${overview.tag}`} className={'divider'} />}
          </Fragment>
        ))}
      </Card.Body>
    </Card>
  );
};

export default SearchResultsSummary;
